/**
 * 分享结果错误码
 */
export var ShareResultCode;
(function (ShareResultCode) {
    /** 0	分享成功 */
    ShareResultCode[ShareResultCode["SUCCESS"] = 0] = "SUCCESS";
    /** -1	分享失败 */
    ShareResultCode[ShareResultCode["FAILED"] = -1] = "FAILED";
    /** -2	分享渠道对应app没安装 */
    ShareResultCode[ShareResultCode["NOT_INSTALL"] = -2] = "NOT_INSTALL";
    /** -3	用户主动取消 */
    ShareResultCode[ShareResultCode["CANCEL"] = -3] = "CANCEL";
    /** -4	相册权限未经用户授权	涉及图片操作时需要该权限 */
    ShareResultCode[ShareResultCode["NOT_PIC_PERMISSION"] = -4] = "NOT_PIC_PERMISSION";
})(ShareResultCode || (ShareResultCode = {}));
